export default __webpack_public_path__ + "static/media/polka-dot-man.bf6eeb67.png";